import { useEffect, useRef } from 'react';

const DEFAULT_TIMEOUT = 30 * 60 * 1000;
const ACTIVITY = ['mousemove', 'keydown', 'click', 'scroll'] as const;

export function useIdleLogout(onTimeout: () => void, timeoutMs: number = DEFAULT_TIMEOUT): void {
  const cb = useRef(onTimeout);
  cb.current = onTimeout;

  useEffect(() => {
    let timer = window.setTimeout(() => cb.current(), timeoutMs);
    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => cb.current(), timeoutMs);
    };
    ACTIVITY.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    return () => {
      window.clearTimeout(timer);
      ACTIVITY.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [timeoutMs]);
}
